const SvgPinterestFa = (props) => (
  <svg viewBox="0 0 448 512" {...props}>
    <g fill="currentColor">
      <path d="M448 256c0 123.7-100.3 224-224 224-23.1 0-45.3-3.5-66.3-10 9.1-14.9 22.8-39.3 27.8-58.7 2.7-10.5 13.9-53.3 13.9-53.3 7.3 13.9 28.6 25.7 51.3 25.7 67.6 0 116.2-62.1 116.2-139.4 0-74-60.4-129.3-138.1-129.3-96.6 0-148 64.9-148 135.6 0 32.9 17.5 73.8 45.4 86.8 4.2 2 6.5 1.1 7.5-3 .7-3.1 4.5-18.3 6.2-25.4.5-2.3.3-4.2-1.5-6.4-9.1-11.3-16.5-31.9-16.5-51.1 0-49.4 37.4-97.2 101.2-97.2 55 0 93.6 37.5 93.6 91.1 0 60.6-30.6 102.6-70.5 102.6-21.9 0-38.5-18.2-33.1-40.5 6.3-26.6 18.5-55.4 18.5-74.6 0-17.2-9.2-31.5-28.4-31.5-22.5 0-40.6 23.2-40.6 54.4 0 19.9 6.7 33.2 6.7 33.2s-22.1 93.8-26.2 111.3c-4.5 19.3-2.7 46.6-.8 64.3C59.1 432 0 350.9 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224z" />
    </g>
  </svg>
)

export default SvgPinterestFa
